import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { TransitionGroup } from 'react-transition-group';

import CssTransition from '../../components/Transition/CssTransition';
import TransitionGroupContainer from '../../components/Transition/TransitionGroupContainer';

import PetitionDetails from './PetitionDetails';
import PetitionSuccess from './PetitionSuccess';
import FindLocalRep from '../LocalRep/FindLocalRep';

const Petition = () => (
    <Route
        render={({ location }) => (
            <TransitionGroup component={TransitionGroupContainer}>
                <CssTransition key={location.pathname} timeoutInMs={650}>
                    <Switch location={location}>
                        <Route
                            path="/petition/start"
                            name="PetitionStart"
                            exact
                            component={PetitionDetails}
                        />
                        <Route
                            path="/petition"
                            name="PetitionDetails"
                            exact
                            component={PetitionDetails}
                        />
                        <Route
                            path="/petition/success"
                            name="PetitionSuccess"
                            exact
                            component={PetitionSuccess}
                        />
                        <Route
                            path="/petition/findRep"
                            name="PetitionFindRep"
                            exact
                            component={FindLocalRep}
                        />
                    </Switch>
                </CssTransition>
            </TransitionGroup>
        )}
    />
);

export default Petition;
